<script lang="ts" setup>
const CLASS_ROOT = 'govuk-message'

interface IDSKMessageProps {
  error?: boolean
}

const props = defineProps<IDSKMessageProps>()
</script>

<template>
  <div :class="`${CLASS_ROOT} ${props.error ? 'error' : 'warning'}`">
    <div class="icon-wrapper">
      <span class="icon" aria-hidden="true"> ! </span>
    </div>

    <div class="text govuk-body">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.govuk-message {
  display: flex;
  align-items: center;
  margin: 0 0 60px;

  .icon-wrapper {
    width: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .icon {
    display: block;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    position: absolute;
    font-size: 30px;
    text-align: center;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .text {
    padding-top: 20px;
    padding-right: 20px;
    flex: 1;
  }

  &.error {
    color: #721c24;
    background: #f8d7da;

    .icon {
      color: #f8d7da;
      background: #721c24;
    }
  }

  &.warning {
    color: black;
    // background: yellow;
    background: var(--idsk-color-yellow);

    .icon {
      background: black;
      // color: yellow;
      color: var(--idsk-color-yellow);
    }
  }
}
</style>
